import './FullScreenLoader.scss';

const FullScreenLoader = () => {
   return (
      <div className="full-screen-loader">
         <div className="loader" />
      </div>
   );
};

export default FullScreenLoader;
